import actions from 'actions/assetCategories'
import { createFormViewContainer } from 'factories/FormView'
import Component from 'components/AssetCategories/FormView'

export default createFormViewContainer({ actions })(Component)
